/** Consistent icon + label layout for buttons and btn-styled links. */
export function BtnIcon({ icon: Icon, size = 16, className = "" }) {
  if (!Icon) return null;
  return <Icon className={`btn-icon ${className}`.trim()} size={size} aria-hidden />;
}

export function BtnContent({ icon, children, iconSize }) {
  if (!icon) return children;
  return (
    <span className="btn-icon-wrap">
      <BtnIcon icon={icon} size={iconSize} />
      <span>{children}</span>
    </span>
  );
}
